export const saveState = state => {
  try {
    var serializedState = JSON.parse(JSON.stringify(state));
    delete serializedState.SessionReducer.turnServer;
    delete serializedState.SessionReducer.sessionDetails.turnServer;
    delete serializedState.SessionReducer.sessionDetails.config;
    delete serializedState.UserReducer.config;
    sessionStorage.setItem("state", JSON.stringify(serializedState));
  } catch (error) {}
};

export const loadState = () => {
  try {
    var serializedState = JSON.parse(sessionStorage.getItem("state"));
    if (serializedState) {
      return serializedState;
    }
  } catch (error) {
    return null;
  }
};
export const clearState = () => {
  try {
    sessionStorage.setItem("state", null);
  } catch (error) {}
};
